import { shuffle } from "./format";
import type { Word } from "@/types/lex";

export interface QuizQuestion {
  word: Word;
  options: string[];
  correct: string;
}

/**
 * Build an MCQ round. `picks` are the words to ask (already prioritized by the
 * caller); `pool` is the whole day, used as the distractor source.
 *
 * Distractors are matched on meaning, not index: several TOEIC entries share a
 * Vietnamese gloss (`cuisine` / `culinary` → "ẩm thực"), and offering both as
 * separate options makes a correct answer look wrong.
 */
export function buildQuiz(picks: readonly Word[], pool: readonly Word[]): QuizQuestion[] {
  const usable = pool.filter((w) => w.meaning_vi);
  if (usable.length < 4) return [];

  return picks
    .filter((w) => w.meaning_vi)
    .map<QuizQuestion>((word) => {
      const distractors = shuffle(usable.filter((w) => w.meaning_vi !== word.meaning_vi))
        .slice(0, 3)
        .map((w) => w.meaning_vi);
      return {
        word,
        options: shuffle([word.meaning_vi, ...distractors]),
        correct: word.meaning_vi,
      };
    });
}
